import type { HelpFile } from '../../types/help'
import { AccountsTestIds } from '../../../testids/AccountsTestIds'

export const accountsHelp: HelpFile = {
  docPage: '/docs/identity/accounts',
  texts: {
    [AccountsTestIds.accountsList]:
      'All accounts known to the system, grouped by their target system. An account is the credential or principal that actually receives access in a downstream system.',
  },
}
